import * as React from 'react';
import styled from 'styled-components';
import { Pulse } from '../Animate';
import BackgroundImage from '../BackgroundImage';

const Wrapper = styled.div({
  height: '32px',
  width: '100%',
  paddingBottom: '2px',
  '@media screen and (min-width: 768px)': {
    height: '36px',
  },
});

const Promotion: React.FC<{ src: string }> = ({ src }) => {
  return (
    <Wrapper>
      <Pulse iterationCount={3}>
        <BackgroundImage src={src} />
      </Pulse>
    </Wrapper>
  );
};

export default Promotion;
